import { IconButton, MenuItem, SvgIcon, Menu } from '@mui/material'
import { MoreVert } from '@mui/icons-material'
import * as React from 'react'
import ConfirmMenuItem from './ConfirmMenuItem/ConfirmMenuItem'
import { IMenuItem } from './ESDataTable'

export interface IESMenuProps {
  data: any
  menuItems: IMenuItem[]
  rowIndex: number
  setSelectedRow?: (idx: number) => void
  icon?: JSX.Element
  titleMenuItem?: string
  menuAriaLabel?: string
}

class ESMenu extends React.Component<IESMenuProps> {
  public state = {
    anchorEl: null,
    isOpen: false,
  }

  public toggleIsOpen = (event: React.MouseEvent) => {
    event.stopPropagation()
    let anchorEl = null
    if (!this.state.isOpen) {
      anchorEl = event.currentTarget
    }
    this.setState({ anchorEl, isOpen: !this.state.isOpen })
    if (this.props.setSelectedRow) {
      this.props.setSelectedRow(this.props.rowIndex)
    }
  }

  public onMenuItemClick =
    (item: IMenuItem) => (event: React.MouseEvent<HTMLElement>) => {
      event.stopPropagation()
      this.setState({ anchorEl: null, isOpen: false })
      return item.onClick(event, this.props.data)
    }
  public onMouseLeave = (item: IMenuItem) => (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    this.setState({ anchorEl: null, isOpen: false })
    return item.onMouseLeave!(event)
  }

  public render() {
    const menuItems: React.ReactNode[] = []
    const menuItemSx = {
      '&.Mui-focusVisible': {
        backgroundColor: 'primary.main',
        color: 'white',
      },
      '&:hover': {
        backgroundColor: 'primary.main',
        color: 'white',
      },
      '&:hover svg': {
        color: 'white !important',
      },
    }

    if (this.props.titleMenuItem) {
      menuItems.push(
        <MenuItem key={`titleMenuItem`} sx={menuItemSx} disabled>
          {this.props.titleMenuItem}
        </MenuItem>
      )
    }
    this.props.menuItems.forEach((item: IMenuItem, idx: number) => {
      if (item.isConfirm) {
        menuItems.push(
          <ConfirmMenuItem
            key={`${item.name}-${idx}`}
            onClick={this.onMenuItemClick(item)}
            onMouseLeave={this.onMouseLeave(item)}
            sx={menuItemSx}
            disabled={item.disabled}
          >
            {!!item.icon && (
              <SvgIcon
                color="inherit"
                component={item.icon}
                style={{ paddingRight: '10px', color: `${item.color}` }}
              />
            )}
            {item.name}
          </ConfirmMenuItem>
        )
      } else {
        menuItems.push(
          <MenuItem
            key={`${item.name}-${idx}`}
            onClick={this.onMenuItemClick(item)}
            sx={menuItemSx}
            disabled={item.disabled}
          >
            {!!item.icon && (
              <SvgIcon
                color="inherit"
                component={item.icon}
                fontSize="large"
                style={{ paddingRight: '10px', color: `${item.color}` }}
              />
            )}
            {item.name}
          </MenuItem>
        )
      }
    })
    return (
      <>
        <IconButton
          id={this.props.menuAriaLabel}
          aria-label={this.props.menuAriaLabel}
          onClick={this.toggleIsOpen}
          style={{ padding: 0 }}
          color="inherit"
          size="large"
        >
          {this.props.icon ? this.props.icon : <MoreVert />}
        </IconButton>
        <Menu
          anchorEl={this.state.anchorEl}
          open={this.state.isOpen}
          onClose={this.toggleIsOpen}
          transformOrigin={{
            horizontal: 'center',
            vertical: 'top',
          }}
        >
          {menuItems}
        </Menu>
      </>
    )
  }
}

export default ESMenu
